import { foodCostColor, catColor, catLabel } from "../lib/constants";

export function FoodCostBadge({ pct, size = "md" }) {
    const hasValue = pct && pct > 0;
    const color = foodCostColor(pct);
    const bg = hasValue ? `${color}15` : "#f1efe9";
    const big = size === "lg";
    return (
        <div
            className={`inline-flex flex-col items-center justify-center rounded-lg border ${
                big ? "px-4 py-3 min-w-[88px]" : "px-3 py-2 min-w-[72px]"
            }`}
            style={{ borderColor: `${color}30`, background: bg }}
            data-testid="food-cost-badge"
        >
            <div
                className={`font-display leading-none ${big ? "text-3xl" : "text-2xl"}`}
                style={{ color }}
            >
                {hasValue ? `${Number(pct).toFixed(1)}%` : "—"}
            </div>
            <div
                className="mt-1 font-sans uppercase font-semibold tracking-[0.14em] text-[9px]"
                style={{ color: hasValue ? color : "#94908a" }}
            >
                Food Cost
            </div>
        </div>
    );
}

export function CategoryBadge({ category, size = "sm" }) {
    const color = catColor(category);
    const label = catLabel(category);
    return (
        <span
            className={`inline-flex items-center rounded-full font-semibold uppercase tracking-wider ${
                size === "sm" ? "px-2 py-0.5 text-[9px]" : "px-3 py-1 text-[10px]"
            }`}
            style={{ background: `${color}18`, color }}
        >
            {label}
        </span>
    );
}
